<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex flex-col sm:flex-row gap-2">
             <div class="relative">
                <input type="text" [(ngModel)]="search" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <div>
                <select (change)="onSelectStatus($event)" id="inputStatus" class="min-w-40">
                    <option [value]="true">Active</option>
                    <option [value]="false">Inactive</option>
                </select>
            </div>
           
        </div>
        <div *ngIf="placeTypeData && placeTypeData.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (placeTypeData.length != 50? (50
                -placeTypeData.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
         <div>
            <button routerLink="add" *ngIf="permissionService.hasPermission([userPermission.MANAGE_PLACE_TYPES])" class="btn btn-secondary">
                Add
            </button>
        </div>
    </div>

    <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap"
                                        *ngIf="permissionService.hasPermission([userPermission.MANAGE_PLACE_TYPES])"
                                        >
                                        Action
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Title</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Description
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                *ngFor="let item of placeTypeData | filter: search | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems:totalResults }; let i=index"
                                >
                                 <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                       {{i+1}}
                                    </td>    
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" *ngIf="permissionService.hasPermission([userPermission.MANAGE_PLACE_TYPES])">
                                        <div class="flex"  >
                                            <button>
                                                <a [appToolTip]="'Edit'" (click)="openPlaceTypeModal(item)" class="cursor-pointer hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                    stroke="currentColor" class="size-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                    </svg>
                                                </a>
                                            </button>
                                        </div>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(item.title | titlecase ) || 'N/A'}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                        <div class="w-72 line-clamp-2">
                                            {{(item.description | titlecase) || 'N/A'}}
                                        </div>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="item.isActive ? 'badge-success':'badge-danger'">{{item.isActive ? 'Active' :
                                            'Inactive'}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>
    
<app-placetype-edit-modal *ngIf="placeTypeModalObj" [placeType]="placeTypeModalObj" (onSave)="onSavePlaceType($event)"
    (onCloseModal)="onClosePlaceTypeModal()"></app-placetype-edit-modal>